// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__2GrwC","loadingText":"Loading_loadingText__eOopK"};